import type { EmailOtpType } from '@supabase/supabase-js'

const CONFIRM_OTP_TYPES = new Set<EmailOtpType>(['signup', 'email'])

function parseSearch(search: string): {
  tokenHash: string | null
  otpType: EmailOtpType | null
  hasCode: boolean
} {
  const params = new URLSearchParams(search)
  const tokenHash = params.get('token_hash')
  const typeParam = params.get('type')
  const otpType =
    typeParam && CONFIRM_OTP_TYPES.has(typeParam as EmailOtpType)
      ? (typeParam as EmailOtpType)
      : null
  return {
    tokenHash,
    otpType,
    hasCode: params.has('code'),
  }
}

function parseHash(hash: string): {
  tokenHash: string | null
  otpType: EmailOtpType | null
  hasAccessToken: boolean
} {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash
  if (!raw) {
    return { tokenHash: null, otpType: null, hasAccessToken: false }
  }
  const params = new URLSearchParams(raw)
  const tokenHash = params.get('token_hash')
  const typeParam = params.get('type')
  const otpType =
    typeParam && CONFIRM_OTP_TYPES.has(typeParam as EmailOtpType)
      ? (typeParam as EmailOtpType)
      : null
  return {
    tokenHash,
    otpType,
    hasAccessToken: params.has('access_token'),
  }
}

/** True when the URL may complete email confirmation (query, hash, or PKCE code). */
export function hasEmailConfirmParams(
  search = window.location.search,
  hash = window.location.hash,
): boolean {
  const q = parseSearch(search)
  if (q.tokenHash && q.otpType) return true
  if (q.hasCode) return true
  const h = parseHash(hash)
  if (h.tokenHash && h.otpType) return true
  if (h.hasAccessToken) return true
  return false
}

/** Path + search + hash for /auth/confirm (preserves tokens from landing). */
export function authConfirmRedirectPath(
  search = window.location.search,
  hash = window.location.hash,
): string {
  return `/auth/confirm${search}${hash}`
}
